DialogController = App.loadClass 'core::Angular/DialogController'

class exports.IrrigationDetailsBase extends DialogController

    constructor: (@scope, @transitions, @modalInstance) ->
        super(@scope, @transitions, @modalInstance)

        @scope.clearInputs = @clearInputs
        @scope.clearSecondaryInputs = @clearSecondaryInputs

    setLoadedEnergySource: () =>
        # special handling to load fuel type or energy source
        if @scope.details.fuel_type_id
            @scope.details.energy_source = @scope.energy_sources.find((source) =>
                return source.id is @scope.details.fuel_type_id and source.default_units?
            )
        else if @scope.details.energy_source_id
            @scope.details.energy_source = @scope.energy_sources.find((source) => source.id is @scope.details.energy_source_id and not source.default_units?)
        else if @scope.details.energy_source
            @scope.details.energy_source = @scope.energy_sources.find((source) =>
                return source.name is @scope.details.energy_source.name
            )

        if @scope.details.secondary_fuel_type_id
            @scope.details.secondary_energy_source = @scope.energy_sources.find((source) =>
                return source.id is @scope.details.secondary_fuel_type_id and source.default_units?
            )
        else if @scope.details.secondary_energy_source_id
            @scope.details.secondary_energy_source = @scope.energy_sources.find((source) => source.id is @scope.details.secondary_energy_source_id and not source.default_units?)
        else if @scope.details.secondary_energy_source
            @scope.details.secondary_energy_source = @scope.energy_sources.find((source) =>
                return source.name is @scope.details.secondary_energy_source.name
            )

    clearInputs: () =>
        @scope.details.energy_source = null
        @scope.details.pump_pressure = null
        @scope.details.pumping_depth = null

    clearSecondaryInputs: () =>
        @scope.details.secondary_energy_source = null
        @scope.details.secondary_pump_pressure = null
        @scope.details.secondary_pumping_depth = null
